import { JsEnv, isClub } from '../../models/js_env';
import { TypedEvent } from '../../../core/typed_event';
import LoadingUtil from '../../../core/util/loading_util';
import { CouponRepository } from '../../repositories/coupon/coupon_repository';
import { CouponModalState } from '../../models/coupon/coupon_modal_state';
import { CouponModalJsEnv } from '../../models/coupon/coupon_modal_js_env';
import { CouponModalContainer } from '../../views/pc/coupon/coupon_modal_container';
import { CouponModal } from './coupon_modal';

export class CouponModalAction {
  static readonly DISPLAY_COUPON_MODAL_EVENT = new TypedEvent<CouponModalJsEnv>();
  private static couponRepository: CouponRepository;
  private static state: CouponModalState;
  private static couponModal: CouponModal;

  static init(env: JsEnv) {
    // クーポンモーダルはCLUBのみ有効化する。
    if (!isClub(env.SITE_TYPE)) return;

    this.couponRepository = new CouponRepository();
    this.state = new CouponModalState(env.PAGE);

    this.couponModal = new CouponModal();

    env.FUNCTIONS.showCouponModal = this.showCouponModal.bind(this);

    return new CouponModalContainer();
  }

  private static async showCouponModal(catalogItemCode: string) {
    LoadingUtil.showLoadingSpinner();

    await this.couponRepository
      .getCouponInformation([], [catalogItemCode], '1')
      .then((result) => {
        if (result && result.code === '00000' && result.cpnAvailableList.length > 0) {
          this.state.updateShouldShowModal(true);
          this.state.updateCoupons(result.cpnAvailableList);
          this.state.updateCatalogItemCode(catalogItemCode);
        } else {
          this.state.updateShouldShowModal(false);
          this.state.updateCoupons([]);
          this.state.updateCatalogItemCode('');
        }
      })
      .catch(() => {
        this.state.updateShouldShowModal(false);
        this.state.updateCoupons([]);
        this.state.updateCatalogItemCode('');
      })
      .then(() => {
        this.DISPLAY_COUPON_MODAL_EVENT.trigger(this.state.getModel());

        const couponModalOpenButton = document.getElementById(
          'coupon-modal-open-button'
        ) as HTMLInputElement;
        couponModalOpenButton.click();

        LoadingUtil.hideLoadingSpinnerHtml();
      });
  }
}
